import { Gallery } from "../gallery";
import { Videos } from "./Videos";

export function MediaBand() {
  return (
    <section className="siat-media-band">
      <div className="siat-wrap siat-media-band__grid">
        <Gallery />
        <Videos />
      </div>
    </section>
  );
}
